import IcoSeniot from '../assets/logo.png';
export default function Nav(props) {
    return (

        <nav className="navbar navbar-expand-lg bg-body-tertiary border-bottom border-bottom-dark fixed-top">
            <div className="container-fluid d-flex justify-content-between">
                <a className="navbar-brand" href="#">
                    <img src={IcoSeniot} alt="Logo" height="70px"
                        className="d-inline-block align-text-top" />
                </a>
                <div>

                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item font-montserrat-bold">
                                <a className="nav-link" href="#contact">Contactanos</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    )
}